import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mainPrompt: {
    defaultMessage: 'Drag and drop a {types} file here',
    id: 'S+PJk8',
    description: 'Main drag and drop files component prompt',
  },
  helpTextAnotherFile: {
    defaultMessage: 'Replace file',
    id: 'H+xiCv',
    description: 'Drag and drop file component help text when file is chosen',
  },
  fileTooBig: {
    defaultMessage: 'File size is too big. Select a file smaller than {filesize}MB.',
    id: 'pmEI8i',
    description: 'Drag and drop file component error when file is too big',
  },
  fileZeroSize: {
    defaultMessage: 'File with no content.',
    id: 'IDL8aH',
    description: 'Drag and drop file component error when file is zero size',
  },
  fileTypeError: {
    defaultMessage: 'File type is not supported. Select {types} file.',
    id: 'UZodyB',
    description: 'Drag and drop file component error when file type is wrong',
  },
  selectFile: {
    defaultMessage: 'Select a file',
    id: 'HKdHna',
    description: 'Drag and drop file component button to select a file',
  },
  or: {
    defaultMessage: 'or',
    id: 'N0sOZ9',
    description: 'Single word "or" denoting the option of two buttons.t',
  },
});
